import { useParams } from 'react-router-dom';

import { isProject, Project } from '@/shared/config/projects';
import { useGlobalStore } from '@/shared/stores/global.store';

export function projectPath(project: Project, path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `/${project}${normalizedPath === '/' ? '' : normalizedPath}`;
}

export function legacyProjectPath(
  activeProject: Project,
  pathname: string,
): string {
  return pathname === '/'
    ? projectPath(activeProject, '/books')
    : projectPath('hatfa', pathname);
}

export function useCurrentProject(): Project {
  const { project } = useParams<{ project: string }>();
  const activeProject = useGlobalStore((state) => state.activeProject);

  return isProject(project) ? project : activeProject;
}

export function useProjectPath() {
  const project = useCurrentProject();
  return (path: string) => projectPath(project, path);
}
